/**
 * The five stages of the candidate's journey, as the progress rail names them
 * [Figma · Stepper `12084:26382`].
 *
 * In its own module rather than beside the component because a file that exports both a component and a
 * constant breaks Vite's fast refresh — and because the sequence is the meaning here: more than one screen
 * reads it, and a rail that disagrees with itself between two adjacent screens is worse than no rail.
 *
 * **No story specifies these.** They appear in the frames and in no spec, which makes them a product
 * statement — there are five stages, and these are their names — that the Ground Truth does not yet record.
 */
export const JOURNEY_STEP = {
  findJob: 'findJob',
  questions: 'questions',
  submitted: 'submitted',
  getSetUp: 'getSetUp',
  allSet: 'allSet',
} as const;
export type JourneyStep = (typeof JOURNEY_STEP)[keyof typeof JOURNEY_STEP];
